import { ClarionButtonLink } from '../clarion/ClarionButtonLink';
import { ClarionNonIdealState } from '../clarion/ClarionNonIdealState';

export default function AccessDenied() {
  return (
    <ClarionNonIdealState
      title="Access Denied"
      description="Sorry, you do not have permission to access this page. If you believe you should have access, please check that you are logged in with the correct account."
      icon="ban-circle"
      action={
        <ClarionButtonLink href="/" intent="primary" size="large">
          Go Home
        </ClarionButtonLink>
      }
    />
  );
}
